import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-colofon',
    templateUrl: './colofon.component.html',
    styleUrls: ['./colofon.component.scss'],
    imports: [MatIcon, RouterLink]
})
export class ColofonPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
